import type { CollectionConfigMapJson } from './collection-config-schema';
import { CollectionConfigMapJsonSchema } from './collection-config-schema';
import type { ProductConfigMapJson } from './product-config-schema';
import { ProductConfigMapJsonSchema } from './product-config-schema';
import { config as rawCollectionConfigJson } from '../data/collection-config-json';
import { config as rawProductConfigJson } from '../data/product-config-json';

const productConfigJson = ProductConfigMapJsonSchema.parse(rawProductConfigJson);
const collectionConfigJson = CollectionConfigMapJsonSchema.parse(rawCollectionConfigJson);

export function loadProductConfiguration(): ProductConfigMapJson {
  return productConfigJson;
}

export function loadCollectionConfiguration(): CollectionConfigMapJson {
  return collectionConfigJson;
}
